export default class NofityMe {
  init() {
    this.handleResponse();
    this.submit();
  }

  handleResponse() {
    $('body').on('product:updateAddToCart', function (e, response) {
      const stockNotificationEnable = response.product.productCTA.notifyMeAvailability;
      const addToCart = 'button.add-to-cart, .add-to-cart-global';
      const notify = '.notifyme-button-container';
      const details = '.details-bottom';
      const sticky = '.sticky-container';

      if (Object.prototype.hasOwnProperty.call(response.product, 'productCTA')) {
        if (stockNotificationEnable) {
          $(addToCart, details).addClass('d-none');
          $(notify, details).removeClass('d-none');
          $(addToCart, sticky).addClass('d-none');
          $(notify, sticky).removeClass('d-none');
        } else {
          $(addToCart, details).removeClass('d-none');
          $(notify, details).addClass('d-none');
          $(addToCart, sticky).removeClass('d-none');
          $(notify, sticky).addClass('d-none');
        }
      }
    });
  }

  submit() {
    $('.notifyme-form').on('submit', function (e) {
      e.preventDefault();
      const form = $(this);
      const error = form.attr('data-unsuccess-msg');
      const quantityRequested = $('.details-top .input-quantity').val();

      $(this).find('.btn-loader').spinner().start();
      $('#quantityRequested').val(quantityRequested);

      $.ajax({
        url: form.attr('action'),
        type: 'POST',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          form.remove();
          $('#notifyme-title').html(data.title);
          $('#notifyme-description').html(data.msg).addClass('alert alert-info mt-3 mb-4');
          $('body').trigger('notifyme:success');
        },
        error: function (data) {
          form.remove();
          $('#notifyme-title').html(data.title);
          $('#notifyme-description').html(error).addClass('alert alert-danger mt-3 mb-4');
          $('body').trigger('notifyme:error');
        }
      });
    });
  }
}
